module.exports = __webpack_public_path__ + "static/screenshot4-9dc725169d3cef0c27164e3c6077e2ee.png";